import 'bootstrap/dist/css/bootstrap.min.css';
import Crud from './crud';
function App() {
  return (
    <div className="App">
    <Crud/>
    </div>
  );
}

export default App;
